export default __webpack_public_path__ + "static/media/book-open-solid.41836a10.svg";